/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ScheduleType } from '@gh/builder-shared-data';
import { createDialogRoute, FormState, FormStateBuilder, getDialogInitData } from '@gh/common-shared';
import { AutocompleteLoadMoreEvent, DialogInput } from '@gh/core-ui';
import {
  JobScheduleCreateDialogConfig,
  ScheduleListBusinessService,
} from '../../resources/schedule-list-business.service';
import { JobScheduleCreate, ScheduleTemplateListItem } from '../../resources/schedule-list.model';

@Component({
  selector: 'gh-job-schedule-create-dialog',
  template: require('./job-schedule-create-dialog.component.html'),
  styles: [require('./job-schedule-create-dialog.component.scss')],
})
export class JobScheduleCreateDialogComponent implements OnInit, DialogInput<JobScheduleCreateDialogConfig> {
  input: JobScheduleCreateDialogConfig;

  form: FormState<JobScheduleCreate>;
  templates: ScheduleTemplateListItem[];

  constructor(@Inject(MAT_DIALOG_DATA) private dialogData: any,
              private dialogRef: MatDialogRef<any>,
              private formStateBuilder: FormStateBuilder,
              private business: ScheduleListBusinessService) {
  }

  get templateLabel(): string {
    // @ts-ignore
    return {
      [ScheduleType.Construction]: 'lbl_construction_template',
      [ScheduleType.PreConstruction]: 'lbl_pre_construction_template',
      [ScheduleType.Maintenance]: 'lbl_maintenance_template',
    }[this.input.type];
  }

  ngOnInit(): void {
    const { templates } = getDialogInitData(this.dialogData);

    this.templates = templates;
    this.form = this.formStateBuilder.buildPlain({
      value: { type: this.input.type },
      children: {
        type: void 0,
        jobId: { required: true },
        templateId: { required: true },
      },
    });
  }

  loadJobs(event: AutocompleteLoadMoreEvent): void {
    event.load(this.business.findAllJobs(this.input.type, event.query));
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onCreate(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    this.dialogRef.close(this.form.submitValue);
  }
}

export const jobScheduleCreateDialogRoute = createDialogRoute({
  component: JobScheduleCreateDialogComponent,
  init: {
    service: ScheduleListBusinessService,
    selector: 'initJobScheduleDialogView',
  },
});
